import { RouteRecordRaw } from 'vue-router';
import { VerificationListPage } from '@/pages/verification';

export const routeName = 'Verificacao';

export const route: RouteRecordRaw = {
  path: 'verificacao',
  name: routeName,
  component: VerificationListPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Etapa de Verificação e Vigência',
    permissions: [{ action: 'manageVerification', subject: 'Homologation' }],
  },
};
